{
  "version": "1.2.6",
  "objects": {
    "7430093515434096834": {
      "type": "frame",
      "id": "7430093515434096834",
      "z": 7283,
      "textContent": "",
      "left": -1058.9060742361248,
      "top": 2478.4115538431247,
      "width": 400,
      "height": 500,
      "scaleX": 0.7694665816350448,
      "scaleY": 0.09858628735634922,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430093515441692747": {
      "type": "wireframe",
      "id": "7430093515441692747",
      "z": 7035,
      "top": 2488.4115538431247,
      "left": -1048.9060742361248,
      "width": 52,
      "height": 52,
      "scaleX": 0.5633296861187359,
      "scaleY": 0.5633296861187359,
      "container": "7430093515434096834",
      "layoutPosition": "Zzzzzx",
      "wireframeName": "avatar",
      "fill": "#D23131",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "triangle-exclamation" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": true
    },
    "7430093515443187381": {
      "type": "frame",
      "id": "7430093515443187381",
      "z": 7036,
      "textContent": "Frame 96",
      "left": -1009.6129305579506,
      "top": 2490.558125682212,
      "width": 400,
      "height": 500,
      "scaleX": 0.5630779820215777,
      "scaleY": 0.05,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430093515434096834",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430093515432686634": {
      "type": "shape",
      "id": "7430093515432686634",
      "z": 7034,
      "shapeName": "text",
      "textContent": "<p>Error banner description</p>",
      "left": -1009.6129305579506,
      "top": 2490.558125682212,
      "width": 159.83333333333334,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7430093515443187381",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430093515443919264": {
      "type": "shape",
      "id": "7430093515443919264",
      "z": 7037,
      "shapeName": "icon",
      "textContent": "",
      "left": -774.3817377493194,
      "top": 2494.848288748442,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10262296167212569,
      "scaleY": 0.10262296167212569,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#BDBDBD",
      "angle": 0,
      "container": "7430093515434096834",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    }
  }
}
